exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".disitem[data-v-f48b59c4]{opacity:.4!important}", ""]);

// exports
